export const SETTING_CONTENTS_NAMES = {
  general: {
    environment: 'Environment',
    theme: 'Theme',
    themes: {
      lightMode: 'Light Mode',
      darkMode: 'Dark Mode',
    } as const,
    font: 'Font',
    fonts: {
      pretendard : 'Pretendard',
      arial: 'Arial',
      verdana: 'Verdana',
      sourceSansPro: 'Source Sans Pro',
      roboto: 'Roboto',
      DIN1451: 'DIN 1451',
    } as const,

    storage: 'Storage',
    cacheManagement: 'Cache Management',
    cacheLimit: 'Cache Limit',
    automaticallyClearCache: 'Automatically Clear Cache',
    intervalDay: 'Interval Day',
    clearCache: 'Clear Cache',
    monitoring: 'Monitoring',
    usageStorage: 'Usage Storage',
    freeStorage: 'Free Storage',
    storageAlertNotification: 'Storage Alert Notification',

    system: 'System',
    GPUAcceleration: 'GPU Acceleration',
    renderingQuality: 'Rendering Quality',
    renderingQualities: {
      high: 'High',
      medium: 'Medium',
      low: 'Low',
    } as const,
    proxySetting: 'Proxy Setting',
    enableProxyServer: 'Enable Proxy Server',
    proxyIPaddress: 'Proxy IP Address',
    proxyPort: 'Proxy Port',
  },
  pacsConnection: {
    client: 'Client',
    AETitle: 'AE Title',
    port: 'Port',
    acceptReceivingStudies: 'Accept receiving studies',
    server: 'Server',
    serverList: 'Server List',
    title: 'Add/Modify Popover',
    name: 'Name',
    address: 'Address',
    protocol: 'Protocol',
    protocols: {
      CMove: 'C-MOVE',
      CGet: 'C-GET',
    } as const,
    add: 'Add',
    delete: 'Delete',
    modify: 'Modify',
    up: 'Up',
    down: 'Down',
    test: 'Test',
    cancel: 'Cancel',
    confirm: 'Confirm',
    setasdefault: 'set as Default',
    seriesNumberBase: 'Base Series Number'
  },
  account: {
    userPopup: 'User Popup',
    preference: 'Preference',
    accountName: 'Account Name',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    lastLogin: 'Last Login',
    group: 'Group',
    accessControl: 'Access Control',
    userList: 'User List',
    status: 'Status',
    email: 'Email',
    name: 'Name',
    twoFA: '2FA',
    type: 'Type',
    note: 'Note',
    disconnection: 'Disconnection',
    add: 'Add',
    modify: 'Modify',
    delete: 'Delete',
    remove: 'Remove',
    search: 'Search',
    backoffice:'Backoffice',
    save: 'Save',
    userView: 'User View',
    password: 'Password',
    userStatus: 'User Status',
    nameR: 'Please enter your name.',
    emailR: 'Please enter your email.',
    emailInvalid: 'Invalid email format.',
    passwordR: 'Please enter your password.',
    passwordR2: 'Use at least 8 characters with letters, numbers, or symbols.'
  },
};

export type ThemeType =
  (typeof SETTING_CONTENTS_NAMES.general.themes)[keyof typeof SETTING_CONTENTS_NAMES.general.themes];
export type FontType =
  (typeof SETTING_CONTENTS_NAMES.general.fonts)[keyof typeof SETTING_CONTENTS_NAMES.general.fonts];
export type ProtocolType =
  (typeof SETTING_CONTENTS_NAMES.pacsConnection.protocols)[keyof typeof SETTING_CONTENTS_NAMES.pacsConnection.protocols];
export type RenderingQualityKeyType = keyof typeof SETTING_CONTENTS_NAMES.general.renderingQualities;
export type RenderingQualityType =
  (typeof SETTING_CONTENTS_NAMES.general.renderingQualities)[keyof typeof SETTING_CONTENTS_NAMES.general.renderingQualities];
